const initialState = {
    total: 0,
    completed: 0,
    lastLabel: '',
};

export default function loadingProgress(state = initialState, action) {
    switch (action.type) {
        case 'LOADING_INIT':
            return { total: action.total, completed: 0, lastLabel: '' };
        case 'LOADING_ITEM_COMPLETE':
            return { ...state, completed: state.completed + 1, lastLabel: action.label };
        default:
            return state;
    }
}
